export default {
  bulkOptions: [
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:estimation:prefillsetgroup:export',
    },
  },
}